import { render, staticRenderFns } from "./WallsSidebarMenu.vue?vue&type=template&id=526bb4d4&scoped=true&"
import script from "./WallsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./WallsSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bb4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526bb4d4')) {
      api.createRecord('526bb4d4', component.options)
    } else {
      api.reload('526bb4d4', component.options)
    }
    module.hot.accept("./WallsSidebarMenu.vue?vue&type=template&id=526bb4d4&scoped=true&", function () {
      api.rerender('526bb4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/WallsSidebarMenu.vue"
export default component.exports